import { useState } from 'react';
import { Popover, Combobox } from '@headlessui/react';
import Icon from '@/Components/UI/Icon/Icon';
import { Button } from '@/Components/UI/Button/Button';
import { getTypeIconPath } from '@/Utils/getTypeIconPath';
import clsx from 'clsx';
import InputField from '@/Components/UI/Form/InputField/InputField';

const ColumnSelector = ({
  options,
  onChange,
  placeholder = 'Columns',
  label = '',
  dropdownClassName = '',
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [query, setQuery] = useState('');

  const filteredOptions = !query
    ? options
    : options.filter((option) => {
        return option.label.toLowerCase().includes(query.toLowerCase());
      });

  const isNoOptions = filteredOptions.length === 0 && query !== '';

  const onInsertButtonClick = (close) => {
    setSelectedOption('');
    setQuery('');
    onChange(selectedOption);
    close();
  };

  return (
    <InputField label={label} className='bg-white rounded'>
      <Popover className='relative w-full outline-none'>
        {({ open, close }) => {
          return (
            <>
              <Popover.Button
                className={
                  'flex items-center px-1 w-full border border-shadow-200 text-ui-secondary !shadow-none placeholder-helper font-normal text-[13px] h-6 rounded focus:outline-none active:border-ocean-blue-400 focus:border-ocean-blue-500 focus:ring-2 focus:ring-midnight-100'
                }
              >
                <Icon className='mr-2 sh' name='plus-circle' size={12} color='#151515' />
                {placeholder}
                <Icon
                  className='absolute ml-2 right-2'
                  name={open ? 'caret-up' : 'caret-down-regular'}
                  size={12}
                  color='#151515'
                />
              </Popover.Button>

              <Popover.Panel
                className={clsx(
                  'flex flex-col absolute z-10 w-full border bg-white border-ui-100 rounded  mt-1 max-h-60 overflow-auto p-2',
                  dropdownClassName
                )}
              >
                <Combobox value={selectedOption} onChange={setSelectedOption}>
                  {() => {
                    return (
                      <>
                        <Combobox.Input
                          className={
                            'px-3 w-full border border-shadow-200 text-ui-helper outline-none font-normal text-sm h-8 rounded shrink-0 mb-2  active:border-ocean-blue-400 focus:border-ocean-blue-500 focus:ring-2 focus:ring-midnight-100'
                          }
                          onChange={(event) => setQuery(event.target.value)}
                          placeholder='Search or Type'
                        />
                        <Combobox.Options className={'w-full max-h-52 overflow-auto'} static>
                          {isNoOptions ? (
                            <div className='relative cursor-default select-none py-2 px-4 text-gray-700'>
                              Nothing found.
                            </div>
                          ) : (
                            filteredOptions.map((option, i) => (
                              <Combobox.Option
                                className={({ active }) =>
                                  clsx(
                                    'relative leading-5 text-ui flex items-center cursor-pointer select-none py-2 pl-3 pr-9 whitespace-pre overflow-hidden text-sm',
                                    active ? 'bg-ocean-blue-100 text-ui rounded' : 'text-ui'
                                  )
                                }
                                key={option.label + i}
                                value={option.value}
                              >
                                {option.type && (
                                  <Icon
                                    name={getTypeIconPath(option.type)}
                                    className='flex-shrink-0 mr-1'
                                  />
                                )}
                                {option.label}
                              </Combobox.Option>
                            ))
                          )}
                        </Combobox.Options>
                      </>
                    );
                  }}
                </Combobox>
                <span className={'my-2 border-t border-ui-200'} />
                <Button
                  color={'oceanBlue'}
                  onClick={() => onInsertButtonClick(close)}
                  className='w-full shrink-0'
                  disabled={isNoOptions}
                >
                  Insert
                </Button>
              </Popover.Panel>
            </>
          );
        }}
      </Popover>
    </InputField>
  );
};

export default ColumnSelector;
